import { FlightsSearchFilterValuesInput } from 'src/__generated__/api';

//TODO: ASK SPINNER TO NOT RETURN NULLS IN THE FILTER LIST VALUES SO THAT WE CAN REMOVE THIS LOGIC
// https://jira.expedia.biz/browse/FODF-856
export const sanitizeFilterValues = (flightsSearchFilterValues: FlightsSearchFilterValuesInput[]) => {
  const cleanedFilterValues = [];

  flightsSearchFilterValues.map(flightsSearchFilterValue => {
    const filterValue = {};

    Object.keys(flightsSearchFilterValue).map(filterValueKey => {
      if (flightsSearchFilterValue[filterValueKey]) {
        filterValue[filterValueKey] = flightsSearchFilterValue[filterValueKey];
      }
    });

    cleanedFilterValues.push(filterValue);
  });

  return cleanedFilterValues;
};
